import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import {
    classificationDirectionsEnum,
    classificationScopes,
    classificationScopesEnum,
    documentTagGroups,
    unitOfMeasuresEnum,
} from "helpers/enums";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import { appendCustomDocumentTagGroups } from "helpers/tagGroup";
import { requiredField } from "helpers/validators";
import React from "react";
import { getDocumentTags } from "sources/books/documentTemplates";
import TagsField from "./tagsField";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    description: {
        label: "Описание",
        inputProps: { name: "description" },
    },
    scope: {
        label: "Назначение",
        inputProps: { name: "scope", type: "select" },
        options: classificationScopes,
    },
    id: {},
    quantity: {},
    unitofmeasure: {},
    type: {},
    fieldDefinitions: {},
};

const initialState = getInitialStateFromConfig(config);

class ClassificationTypesForm extends BookShow {
    componentDidMount() {
        this.context?.setPrevItemId(Number(this.props.match.params.id));
        const initial = this.props.initialState;
        this.setState({ data: initial, initial });
        getDocumentTags().then((res) => {
            if (res) {
                const documentTags = Object.entries(Object.groupBy(res, (item) => item.group) || {}).map(
                    ([group, tags]) => ({
                        text: enumLabel(documentTagGroups, group),
                        items: tags.map((tag) => ({
                            text: tag.localizedName,
                            id: tag.localizedName,
                        })),
                    }),
                );

                this.setState({ documentTags: appendCustomDocumentTagGroups(documentTags) });
            }
            this.getItem(this.props);
        });
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => {
                data = {
                    ...data,
                    quantity: 1,
                    unitofmeasure: unitOfMeasuresEnum.None,
                    type: classificationDirectionsEnum.CargoTransportation,
                    scope: data.scope || classificationScopesEnum.Single,
                    fieldDefinitions: null,
                };
                this.setState({ data, initial: data, ...defParams });
            });
        } else {
            this.setState({
                ...defParams,
                data: {
                    ...this.state.data,
                    quantity: 1,
                    unitofmeasure: unitOfMeasuresEnum.None,
                    type: classificationDirectionsEnum.CargoTransportation,
                    scope: classificationScopesEnum.Single,
                    fieldDefinitions: null,
                },
            });
        }
    };

    apply = () => {
        const { source, match, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source.apply(serializeReq({ ...match.params, ...state.data })).then((res) => {
                    if (res) {
                        match.params.id ? this.update() : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    get dropdActions() {
        if (this.props.match.params.id) {
            return [{ text: "Удалить", action: this.actionClose }];
        } else {
            return [];
        }
    }

    renderButton = () => {
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="d-flex justify-content-end">
                <div className={cname} onClick={this.apply}>
                    {this.props.match.params.id ? "Обновить" : "Сохранить"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.name)}
                {this.renderSelect(config.scope)}
                <TagsField
                    value={this.state.data.description}
                    onChange={(value) => this.setValue({ name: "description", value })}
                    documentTags={this.state.documentTags}
                />
                {this.renderButton()}
            </>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <ClassificationTypesForm {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "classification-types");
